import { render, staticRenderFns } from "./ChooseSeatFlow.vue?vue&type=template&id=ed96e0b6&"
import script from "./ChooseSeatFlow.vue?vue&type=script&lang=js&"
export * from "./ChooseSeatFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports